// Credits to https://github.com/sindresorhus/ts-extras

type ObjectKeys<T extends object> = `${Exclude<keyof T, symbol>}`;

export const objectKeys = Object.keys as <Type extends object>(
  value: Type,
) => Array<ObjectKeys<Type>>;

type ValueOf<T> = T[keyof T];

type ObjectEntries<T> = [keyof T, ValueOf<T>][];

export function objectEntries<T extends object>(obj: T): ObjectEntries<T> {
  return Object.entries(obj) as ObjectEntries<T>;
}

// export const objectEntries = Object.entries as <
//   Type extends Record<PropertyKey, unknown>,
// >(
//   value: Type,
// ) => Array<[ObjectKeys<Type>, Required<Type>[ObjectKeys<Type>]]>;
